const initialState = {
    matchingTypes: [],
    matchingTypesForSelectionBox: [],
    matchStatusTypes: [],
    matchStatusTypesForSelectionBox: [],
    defaultFilters: [],
    defaultFiltersForSelectionBox: [],
    defaultMatchingConditions: [],
    defaultMatchingConditionsForSelectionBox: [],
    defaultFixedConditionsForSelectionBox: [],
    refDataMatchingConditions: [],
    refDataMatchingConditionsForSelectionBox: [],
    refDataFixedConditions: [],
    refDataFixedConditionsForSelectionBox: [],
};
export default initialState;